"use strict";

var _require = require("./get-key-value"),
    getValue = _require.getValue;

var setValue = require("./set-key-value");

module.exports.getValue = getValue;
module.exports.setValue = setValue;


//////////////////
// WEBPACK FOOTER
// ./node_modules/map-factory/dist/lib/object-mapper/object-mapper.js
// module id = qvxY
// module chunks = 9